import {
  IGetEarlyAccessPaywallMicrofrontendRequest,
  IMappers,
  TGetEarlyAccessPaywallMicrofrontendModel,
  TGetEarlyAccessPaywallMicrofrontendResponse,
} from './types';

import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

const defaultConfig: TGetEarlyAccessPaywallMicrofrontendModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'early-access-paywall-frontend',
  pathApi: '/v1/get-early-access-paywall-microfrontend/',
} as TGetEarlyAccessPaywallMicrofrontendModel;

function createGetEarlyAccessPaywallMicrofrontendModel(
  parameters: IGetEarlyAccessPaywallMicrofrontendRequest,
): TGetEarlyAccessPaywallMicrofrontendModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHeaderMicrofrontendOptions<TResponse200> {
  httpApi: IHttpApi;
  parameters?: IGetEarlyAccessPaywallMicrofrontendRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

async function fetchGetEarlyAccessPaywallMicrofrontend<TResponse200>({
  httpApi,
  parameters = {},
  config,
  mappers,
}: IGetHeaderMicrofrontendOptions<TResponse200>): Promise<TResponse200 | TGetEarlyAccessPaywallMicrofrontendResponse> {
  const { response, statusCode, headers } = await httpApi.fetch(
    createGetEarlyAccessPaywallMicrofrontendModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response);
    }
  }

  return { response, statusCode, headers } as TGetEarlyAccessPaywallMicrofrontendResponse;
}

export { defaultConfig, createGetEarlyAccessPaywallMicrofrontendModel, fetchGetEarlyAccessPaywallMicrofrontend };
